export const endpoints = {
  adpLogin: '/v2/integrations/adp/login-details',
  login: '/v2/auth/login',
  logout: 'v2/logout',
  register: '/v2/auth/signup',
  resetPassword: 'v2/auth/password/reset',
  forgotPassowrd: 'v2/auth/password/email',
  changeExpiredPassword: 'v2/auth/password/expired',
  whoIsWorking: { base: 'v2/workingUsers', geoLocations: 'v2/geo-locations/{timesheetId}' },
  countByModule: 'v2/modules?module={moduleName}',
  onBoardingStep: '/v2/freeTrialChecklist',
  employee: {
    activateEmployee: '/v2/users/activate',
    base: 'v2/users',
    deactivateEmployee: '/v2/users/deactivate',
    paginatedEmployee: 'v2/users/paginate',
    employeeById: 'v2/users/{id}',
    resendInvite: 'v2/user/resendInvite',
    importEmployees: 'v2/users/import',
    downloadImportSample: 'v2/download-users-csv-sample',
    trackLocation: 'v2/users/track-location',
    trackMileage: 'v2/users/track-mileage',

    // Groups
    group: 'v2/groups',
    paginatedGroup: 'v2/groups/paginate',
    groupById: 'v2/groups/{id}',
  },
  employeeTimeClock: {
    clockIn: 'v2/home/clockInAjax',
    clockOut: 'v2/home/clockOutAjax',
  },
  messageBlast: {
    sentMessages: 'v2/messages/sent',
    receivedMessages: 'v2/messages/received',
    sendMessages: 'v2/messages',
    viewMessageById: 'v2/messages/{id}',
    deleteMessages: 'v2/messages',
    markedAsRead: 'v2/messages/read',
  },
  job: {
    base: 'v2/jobs',
    jobsById: 'v2/jobs/{id}',
    jobActivitiesById: 'v2/jobs/{id}/recentActivity',
    paginatedJobs: 'v2/jobs/paginate',
    activateJobs: 'v2/jobs/activate',
    deactivateJobs: 'v2/jobs/deactivate',
    bulkAssign: 'v2/jobs/bulkAssign',
    bulkAssignEmployeeAndGroupsToJobs: 'v2/jobs/{id}/assignUsers',
    downloadImportSample: 'v2/download-jobs-csv-sample',
    forwardGeocoding: 'v2/get-job-location',
    geofence: 'v2/jobs/geofence',
    trackMileage: 'v2/jobs/track-mileage',
    deleteCustomGeofence: 'v2/jobs/delete-custom-boundaries',

    importJobs: 'v2/jobs/import',
  },
  imports: {
    checkImportStatus: 'v2/data-import/status',
    mapCSVFields: 'v2/data-import/mapping/{importId}',
    startCSVImport: 'v2/data-import/start/{importId}',
  },
  task: {
    base: 'v2/tasks',
    tasksById: 'v2/tasks/{id}',
    paginatedTasks: 'v2/tasks/paginate',
    activateTasks: 'v2/tasks/activate',
    deactivateTasks: 'v2/tasks/deactivate',
    downloadImportSample: 'v2/download-tasks-csv-sample',
    importTasks: 'v2/tasks/import',
  },
  profile: {
    base: 'v2/update-user-account',
    changePassword: 'v2/change-user-password',
    userDetails: 'v2/details',
    changeProfileImage: 'v2/change-profile-image',
    removeProfileImage: 'v2/remove-user-image',
  },
  timeClock: {
    clockOut: 'v2/users-clockout',
    clockIn: 'v2/users-clockin',
    checkClockIn: 'v2/check-user-timesheet',
    bulkClockIn: 'v2/multiple-users-clockin',
    bulkClockOut: 'v2/multiple-users-clockout',
  },
  breakRules: {
    base: 'v2/break-rules',
    paginatedBreakRules: 'v2/break-rules/paginate',
    breakRulesById: 'v2/break-rules/{id}',
    deleteBreakRules: 'v2/break-rules/delete',
    activateBreakRules: 'v2/break-rules/activate',
    deactivateBreakRules: 'v2/break-rules/deactivate',
  },
  breaks: {
    base: 'v2/breaks',
    paginatedBreaks: 'v2/breaks/paginated',
    stopBreak: 'v2/breaks/stop',
    deleteBreak: '/v2/breaks/delete',
  },
  californiaBreakRules: {
    base: 'v2/california-break-settings',
    activate: 'v2/california-break-settings/activate',
    assignUser: 'v2/california-break-settings/assign',
    activeUsers: 'v2/california-break-settings/active-users',
    activeGroups: 'v2/california-break-settings/active-groups',
    unassignUsers: 'v2/california-break-settings/unassign',
    unassignGroups: 'v2/california-break-settings/unassign-groups',
    bulkAssignUser: 'v2/california-break-settings/bulk-assign',
    assignedUsers: 'v2/california-break-settings/assigned-users',
    unassignedUsers: 'v2/california-break-settings/unassigned-users',
    deactivate: 'v2/california-break-settings/deactivate',
  },
  caliBreaks: {
    base: 'v2/cali-breaks',
    paginatedBreaks: 'v2/cali-breaks/paginated',
  },
  dailySignOffs: {
    saveDailySignoff: 'v2/cali-daily-sign-offs',
    updateDailySignoff: 'v2/cali-daily-sign-offs/{id}',
    waiveDailySignoffs: 'v2/cali-daily-sign-offs/waive',
  },
  signatures: {
    upload: 'v2/signatures/upload',
    delete: 'v2/signatures/delete',
  },
  timeOff: {
    category: 'v2/time-off-category',
    paginatedCategory: 'v2/time-off-category/lists',
    categoryById: 'v2/time-off-category/{id}',
    deleteCategory: 'v2/time-off-category/bulk/delete',
    request: 'v2/time-off',
    paginatedRequest: 'v2/time-off/lists',
    paginatedApproveReject: 'v2/time-off/approve-or-disapprove/lists',
    requestById: 'v2/time-off/{id}',
    bulkDeleteRequest: 'v2/time-off/bulk/delete',
    approveRequest: 'v2/time-off-pto-request/bulk/approve',
    rejectRequest: 'v2/time-off-pto-request/bulk/reject',
    singleApproveRequest: 'v2/time-off-pto-request/approve',
    singleRejectRequest: 'v2/time-off-pto-request/reject',
  },
  timesheet: {
    paginatedTimesheet: 'v2/timesheets/paginate',
    base: 'v2/timesheets',
    timesheetById: 'v2/timesheets/{id}',
    approveTimesheet: 'v2/timesheets/approve',
    rejectTimesheet: 'v2/timesheets/unapprove',
    deleteTimesheet: 'v2/timesheets/delete',
    recalculateMileage: 'v2/timesheets/recalculate-mileage',
    quickTimeEntry: 'v2/quick-time-entry',
    filesById: 'v2/files/{fileId}',
    segmented: 'segmented/timesheet/{id}',
  },
  companySettings: {
    base: 'v2/settings?type={settingsName}',
    timezones: 'v2/timezones',
    generalSettings: 'v2/general-settings',
    reportSettings: 'v2/report-settings',
    scheduleSettings: 'v2/scheduling-settings',
    defaultPayrollOvertimeId: 'v2/payroll-settings/defaultPayroll/{id}',
    payrollOvertimeId: 'v2/payroll-settings/payroll/{id}',
    payrollOvertimeActiveUsers: 'v2/payroll-settings/active-users',
    payrollOvertimeActiveGroups: 'v2/payroll-settings/group-users',
    payrollOvertimeAssignees: 'v2/payroll-settings/assignees',
    payrollOvertimeUnAssign: 'v2/payroll-settings/unassign',
    payrollOvertimeFilteredAssignees: 'v2/payroll-settings/filtered-assignees',
    payrollSettings: 'v2/payroll-settings',
    payrollSettingsBasedId: 'v2/payroll-settings/{id}',
    payrollSettingsAssign: 'v2/payroll-settings/assign',
    payrollSettingsIdAssigneeId: 'v2/payroll-settings/{payrollId}/assignee/{id}',
    payrollSettingsAssigneesBasedId: 'v2/payroll-settings/assignees/{id}',
    payrollSettingsGroupsBasedId: 'v2/payroll-settings/groups/{id}',
    payrollSettingsWeekStart: 'v2/payroll-settings/week-start',
    timeRoundingSettings: 'v2/time-rounding-settings',
    notificationSettings: 'v2/notification-settings',
    faceRecognitionSettings: 'v2/facial-recognition-settings',
    paginatedKioskDevices: 'v2/devices/paginate',
    deleteKioskDevice: 'v2/devices/delete',
    kioskDevice: 'v2/devices',
    kioskDeviceById: 'v2/devices/{id}',
    paginatedAuditLogs: 'v2/audit-logs/paginate',
    shortestDistance: 'v2/shortest-distance',
    segmentedTracking: 'v2/segmented-tracking',
    signatures: 'v2/signature-settings',
    trackerChecklist: 'v2/tracker-checklists',
    commuterMileageSettings: 'v2/commuter-mileage-settings',
    evvSettings: 'v2/evv-settings',
    evvProviders: 'v2/evv-settings/evv-providers',
    evvDataProviders: 'v2/evv-settings/evv-data-providers',
    advancedNotificationSettings: 'v2/advanced-notification-settings',
    deactivateNotificationSettings: 'v2/advanced-notification-settings/deactivate',
    activateNotificationSettings: 'v2/advanced-notification-settings/activate',
    deleteNotificationSettings: 'v2/advanced-notification-settings/delete',
    updateNotificationSetting: 'v2/advanced-notification-settings/update/{notificationId}',
  },
  integrations: {
    integrationList: 'v2/integrations/list',
    revokeZapierKey: 'v2/integrations/zapier/revoke-token?api_key={key}',
    generateZapierApiKey: 'v2/integrations/zapier/generate-token',

    generatePublicApiKey: 'v2/integrations/public-api/generate-key',
    revokePublicApiKey: 'v2/integrations/public-api/revoke-key',
    publicApiKey: 'v2/integrations/public-api/get-key',

    adpUniqueKey: 'v2/adp-wfn/subscription/adp/unique-key',
    adpAuthCode: 'v2/adp-wfn/subscription/get-authorization-code',
    adpSaveAuthCode: 'v2/adp-wfn/subscription/create/adp/callback',
    adpGroupCodes: 'v2/adp-wfn/subscription/adp/getGroupCodes',
    adpPaginatedWorkers: 'v2/integrations/adp/employees',
    adpPaginatedTimeeroEmployees: 'v2/integrations/adp/users',
    adpHomeCostPaginatedGroups: 'v2/integrations/adp/cost-codes',
    adpHomeCostCodes: 'v2/integrations/adp/cost-codes',
    adpHomeCostMapGroupToCostCodes: 'v2/integrations/adp/map-job-to-cost-code',
    adpHomeCostUnmapGroupToCostCodes: 'v2/integrations/adp/unmap-job-to-cost-code',
    adpMapWorker: 'v2/integrations/adp/map-user',
    adpImportWorkers: 'v2/integrations/adp/import-employee',
    adpPaginatedCompanies: 'v2/adp-wfn/subscription/adp/getAllCompanies',
    adpPaginatedEarningCodes: 'v2/adp-wfn/subscription/adp/getAllCodesByCompanies',
    adpMapEarningCodes: 'v2/adp-wfn/subscription/adp/mapEarningCode',
    adpSelectedEarningCodes: 'v2/adp-wfn/subscription/adp/codes',
    adpReconnect: 'v2/adp-wfn/subscription/create/adp/reconnect',
    adpWorkerSync: 'v2/integrations/adp/syncWFN',
    adpUnmapWorker: 'v2/integrations/adp/remove-mapping',
    adpMapBulkCostCodeJobs: 'v2/integrations/adp/map-job-to-cost-code-bulk',
    adpBulkUnmapCostCodeJobs: 'v2/integrations/adp/unmap-job-to-cost-code-bulk',
    adpSettings: 'v2/integrations/adp/adp-wfn-settings',
    adpBulkMapUnmap: 'v2/integrations/adp/map-bulk-user',
    adpTimeeroJobs: 'v2/integrations/adp/jobs',
    adpTimeeroTasks: 'v2/integrations/adp/tasks',
    syncStatus: 'v2/integrations/sync/status',

    quickbookAuthCode: 'v2/integrations/quickbooks-online/get-authorization-code',
    quickbookSaveAuthCode: 'v2/integrations/quickbooks-online/save-authorization-code',
    quickbookPaginatedEmployees: 'v2/integrations/quickbooks-online/employees',
    quickbookPaginatedCustomers: 'v2/integrations/quickbooks-online/customers/',
    quickbookPaginatedServiceItem: 'v2/integrations/quickbooks-online/service-items/',
    quickbookOnlinePaginatedTaskList: 'v2/integrations/quickbooks-online/tasks',
    quickbookOnlinePaginatedTimeeroEmployeeList: 'v2/integrations/quickbooks-online/user',
    quickbookMapEmployee: 'v2/integrations/quickbooks-online/map-employee',
    quickbookMapBulkEmployee: 'v2/integrations/quickbooks-online/map-bulk-employee',
    quickbookMapCustomer: 'v2/integrations/quickbooks-online/map-customer',
    quickbookMapBulkCustomer: 'v2/integrations/quickbooks-online/map-bulk-customer',
    quickbookMapServiceItem: 'v2/integrations/quickbooks-online/map-service-item',
    quickbookMapBulkServiceItem: 'v2/integrations/quickbooks-online/map-bulk-service-item',
    quickbookUnmapEmployee: 'v2/integrations/quickbooks-online/remove-employee-map',
    quickbookUnmapCustomer: 'v2/integrations/quickbooks-online/remove-customer-map',
    quickbookUnmapServiceItem: 'v2/integrations/quickbooks-online/remove-service-item-map',
    quickbookImportTask: 'v2/integrations/quickbooks-online/import-task',
    quickbookImportJob: 'v2/integrations/quickbooks-online/import-job',
    quickbookSync: 'v2/integrations/quickbooks-online/sync',
    quickbookDisconnect: 'v2/integrations/quickbooks-online/disconnect',
    quickbookDeleteEmployee: 'v2/integrations/quickbooks-online/delete-employee',
    quickbookDeleteCustomer: 'v2/integrations/quickbooks-online/delete-customer',
    quickbookDeleteService: 'v2/integrations/quickbooks-online/delete-service',
    quickBookOnlineSaveSettings: 'v2/integrations/quickbooks-online/save-settings',
    quickBookOnlineGetSettings: 'v2/integrations/quickbooks-online/get-settings',
    quickBookOnlineChartAccount: 'v2/integrations/quickbooks-online/chart-of-accounts',

    gustoGetCompany: 'v2/integrations/gusto/get-companies',
    gustoAttachCompany: 'v2/integrations/gusto/attach-company',
    gustoAuthCode: 'v2/integrations/gusto/get-authorization-code',
    gustoSaveAuthCode: 'v2/integrations/gusto/save-authorization-code',
    gustoMapEmployeeAndJob: 'v2/integrations/gusto/map-employee-and-job',
    gustoUnmapEmployee: 'v2/integrations/gusto/remove-map',
    gustoMapJob: 'v2/integrations/gusto/map-gusto-job/',
    gustoRemoveMapping: 'v2/integrations/gusto/remove-map/',
    gustoPaginatedEmployee: 'v2/integrations/gusto/employees',
    gustoPaginatedJob: 'v2/integrations/gusto/jobs',
    gustoPaginatedTimeeroEmployee: 'v2/integrations/gusto/timeero-employees',
    gustoImportEmployees: 'v2/integrations/gusto/import-employees',
    gustoDisconnect: 'v2/integrations/gusto/disconnect',
    gustoSync: 'v2/integrations/gusto/sync',

    ripplingAuthCode: 'v2/integrations/rippling/get-authorization-code',
    ripplingSaveAuthCode: 'v2/integrations/rippling/save-authorization-code',
    ripplingSync: 'v2/integrations/rippling/sync',
    ripplingPaginatedEmployee: 'v2/integrations/rippling/rippling-employees',
    ripplingPaginatedTimeeroEmployee: 'v2/integrations/rippling/timeero-employees',
    ripplingEarningTypes: 'v2/integrations/rippling/earning-types',
    ripplingMapEmployees: 'v2/integrations/rippling/map-employee',
    ripplingMapMileageEarning: 'v2/integrations/rippling/map-mileage-earning',
    ripplingRemoveEmployeeMap: 'v2/integrations/rippling/remove-employee-map',
    ripplingImportEmployee: 'v2/integrations/rippling/import-rippling-employee',
    ripplingDisconnect: 'v2/integrations/rippling/disconnect',
    ripplingDeleteEmployee: 'v2/integrations/rippling/delete-employee',

    quickbookDesktopSetBillable: 'v2/integrations/quickbooks-desktop/set-billable',
    quickbookDesktopEmployeeList: 'v2/integrations/quickbooks-desktop/employees',
    quickbookDesktopCustomerList: 'v2/integrations/quickbooks-desktop/customers',
    quickbookDesktopServiceItemList: 'v2/integrations/quickbooks-desktop/service-items',
    quickbookDesktopClassList: 'v2/integrations/quickbooks-desktop/classes',
    quickbookDesktopMapEmployee: 'v2/integrations/quickbooks-desktop/map-user',
    quickbookDesktopUnMapEmployee: 'v2/integrations/quickbooks-desktop/unmap-user',
    quickbookDesktopBulkMapEmployee: 'v2/integrations/quickbooks-desktop/map-bulk-employee',
    quickbookDesktopMapJob: 'v2/integrations/quickbooks-desktop/map-job',
    quickbookDesktopUnMapJob: 'v2/integrations/quickbooks-desktop/unmap-job',
    quickbookDesktopMapServiceItem: 'v2/integrations/quickbooks-desktop/map-tasks',
    quickbookDesktopUnMapServiceItem: 'v2/integrations/quickbooks-desktop/unmap-tasks',
    quickbookDesktopMapClass: 'v2/integrations/quickbooks-desktop/map-class',
    quickbookDesktopUnMapClass: 'v2/integrations/quickbooks-desktop/unmap-class',
    quickbookDesktopImportCustomer: 'v2/integrations/quickbooks-desktop/import-jobs',
    quickbookDesktopImportServiceItem: 'v2/integrations/quickbooks-desktop/import-tasks',
    quickbookDesktopImportClass: 'v2/integrations/quickbooks-desktop/import-class',
    quickbookDesktopGenerateQWC: 'v2/integrations/quickbooks-desktop/generate-qwc',
    quickbookDesktopTimeeroEmployees: 'v2/integrations/quickbooks-desktop/users',
    quickbookDesktopTimeeroTasks: 'v2/integrations/quickbooks-desktop/tasks',
    quickbookDesktopTimeeroGroups: 'v2/integrations/quickbooks-desktop/groups',
    quickbookDesktopTimeeroJobs: 'v2/integrations/quickbooks-desktop/jobs',
    quickbookDesktopDisconnect: 'v2/integrations/quickbooks-desktop/disconnect',
    quickbookDesktopSettingList: 'v2/integrations/quickbooks-desktop/qbd-setting-list',
    quickbookDesktopSetting: 'v2/integrations/quickbooks-desktop/qbd-setting',
    quickbookDesktopPayrollOptions: 'v2/integrations/quickbooks-desktop/payrolls',
    quickbookDesktopQueueEmployeeCustomerList: 'v2/integrations/quickbooks-desktop/employee-and-customer-list',
    quickbookDesktopSaveServiceItem: 'v2/integrations/quickbooks-desktop/save-service-item',

    paychexConnect: 'v2/integrations/paychex/connect',
    paychexDisconnect: 'v2/integrations/paychex/disconnect',
    paychexEmployeeList: 'v2/integrations/paychex/user',
    paychexTaskList: 'v2/integrations/paychex/task',
    paychexTimeoffCategoryList: 'v2/integrations/paychex/time-off-category?search=Time off working',
    paychexAssignWorkerId: 'v2/integrations/paychex/assign-worker-id',
    paychexAssignTask: 'v2/integrations/paychex/assign-task',
    paychexAssignPayComponent: 'v2/integrations/paychex/assign-time-pay-component',
    paychexUpdateClientInformation: 'v2/integrations/paychex/client-pay-component',
    paychexRemoveWorkerIdAndPayComponent: 'v2/integrations/paychex/remove-assign',
    paychexClientInformation: 'v2/integrations/paychex/client-pay-component-list',

    paylocityConnect: 'v2/integrations/paylocity/connect',
    paylocitySync: 'v2/integrations/paylocity/sync',
    paylocityEarningCodes: 'v2/integrations/paylocity/earning-codes',
    paylocityEmployees: 'v2/integrations/paylocity/employees',
    paylocityExportStatus: 'v2/reports/get-paylocity-export-statuses',
    paylocityJobs: 'v2/integrations/paylocity/jobs',
    paylocityMapEmployee: 'v2/integrations/paylocity/map-employee',
    paylocityMapEmployeeId: 'v2/integrations/paylocity/map-employee/{id}',
    paylocityMapBulkEmployee: 'v2/integrations/paylocity/map-employee-bulk',
    paylocityMapJob: 'v2/integrations/paylocity/map-job',
    paylocityUnmapJob: 'v2/integrations/paylocity/map-job/{id}',
    paylocityDeleteJob: '/integrations/paylocity/jobs/{id}',
    paylocityMapEarningCodeSingle: 'v2/integrations/paylocity/map-earning-code/{id}',
    paylocityMappedEarningCodes: 'v2/integrations/paylocity/mapped-earning-codes',
    paylocityMapEarningCodes: 'v2/integrations/paylocity/map-earning-code-bulk',
    paylocitySettings: 'v2/integrations/paylocity/get-settings',
    paylocityDisconnect: 'v2/integrations/paylocity/disconnect',

    xeroAuthCode: 'v2/integrations/xero/get-authorization-code',
    xeroSaveAuthCode: 'v2/integrations/xero/save-access-token',
    xeroSync: 'v2/integrations/xero/sync',
    xeroPaginatedEmployee: 'v2/integrations/xero/xero-user',
    xeroPaginatedTimeeroEmployee: 'v2/integrations/xero/timeero-user',
    xeroPaginatedPayItem: 'v2/integrations/xero/xero-pay-item',
    xeroPaginatedTimeeroPayItem: 'v2/integrations/xero/timeero-pay-item',
    xeroMapEmployees: 'v2/integrations/xero/map-user',
    xeroMapPayItem: 'v2/integrations/xero/map-pay-item',
    xeroRemoveMap: 'v2/integrations/xero/remove-map',
    xeroImportEmployee: 'v2/integrations/xero/import-employee',
    xeroDisconnect: 'v2/integrations/xero/disconnect',

    viventiumLogin: 'v2/integrations/viventium/login',
    viventiumSettings: 'v2/integrations/viventium/get-settings',
    viventiumPayrollSync: 'v2/integrations/viventium/sync-payrolls',
    viventiumPayrolls: 'v2/integrations/viventium/payrolls',
    viventiumSyncAll: 'v2/integrations/viventium/sync',
    viventiumEmployees: 'v2/integrations/viventium/employees',
    viventiumMapEmployee: 'v2/integrations/viventium/map-employee',
    viventiumMapEmployeeBulk: 'v2/integrations/viventium/map-employee-bulk',
    viventiumEmployeeMapId: 'v2/integrations/viventium/map-employee/{id}',
    viventiumEmployeeId: 'v2/integrations/viventium/employees/{id}',
    viventiumDisconeect: 'v2/integrations/viventium/disconnect',
    viventiumEarningCodeSettings: 'v2/integrations/viventium/map-earning-code-bulk',
    viventiumEarningCodes: 'v2/integrations/viventium/earning-codes',

    publicApi: {
      subscriptionList: 'v2/webhooks/subscription/list',
      subscribeWebhook: 'v2/webhooks/subscription/subscribe',
      unsubscribeWebhook: 'v2/webhooks/subscription/unsubscribe',
    },

    paychexApi: {
      connect: 'v2/integrations/paychex/api/connect',
      disconnect: 'v2/integrations/paychex/api/disconnect',
      syncData: 'v2/integrations/paychex/api/sync',
      payPeriod: 'v2/integrations/paychex/api/pay-periods',
      paySettings: 'v2/integrations/paychex/api/components',
      paginatedWorkers: 'v2/integrations/paychex/api/workers',
      paginatedTimeeroUsers: 'v2/integrations/paychex/api/timeero-users',
      paginatedTimeeroJobs: 'v2/integrations/paychex/api/timeero-jobs',
      mapWorkers: 'v2/integrations/paychex/api/map-employee',
      removeWorkers: 'v2/integrations/paychex/api/remove-mapping',
    },

    RUNByADP: {
      connectorCode: 'v2/adp-run/subscription/connector',
      connectUrl: 'v2/adp-run/subscription/connect',
      authorizationCode: 'v2/adp-run/subscription/authorization-code',
      disconnect: 'v2/adp-run/subscription/disconnect',
      importWorkers: 'v2/adp-run/subscription/import-workers',
      mapWorkers: 'v2/adp-run/subscription/map-workers',
      removeMappings: 'v2/adp-run/subscription/remove-mappings',
      workers: 'v2/adp-run/subscription/workers',
      timeeroEmployees: 'v2/adp-run/subscription/users',
      syncWorkers: 'v2/adp-run/subscription/sync-workers',
      earningCodes: 'v2/adp-run/subscription/earning-codes',
      mapEarnings: 'v2/adp-run/subscription/map-earning-codes',
      syncEarnings: 'v2/adp-run/subscription/sync-earning-codes',
      earnings: 'v2/adp-run/subscription/earnings',
      timeeroJobs: 'v2/adp-run/subscription/jobs',
      syncDepartments: 'v2/adp-run/subscription/sync-departments',
      departments: 'v2/adp-run/subscription/departments',
      mapDepartment: 'v2/adp-run/subscription/map-departments',
      settings: 'v2/adp-run/subscription/settings',
      enableDisableDepartment: 'v2/adp-run/subscription/enable-department-codes',
      removeDepartmentMapping: 'v2/adp-run/subscription/remove-department-mappings',
      syncAllModules: 'v2/adp-run/subscription/sync',
      bulkMapUnmapDepartments: 'v2/adp-run/subscription/map-bulk-departments',
      bulkMapUnmapWorkers: 'v2/adp-run/subscription/map-bulk-workers',
    },
    sandataIndiana: {
      connect: 'v2/integrations/sandata-indiana/connect',
      disconnect: 'v2/integrations/sandata-indiana/disconnect',
      tasks: 'v2/integrations/sandata-indiana/tasks',
    },

    pimsy: {
      connect: 'v2/integrations/pimsy/connect',
      disconnect: 'v2/integrations/pimsy/disconnect',
      syncAll: 'v2/integrations/pimsy/sync',
      pimsySettings: 'v2/integrations/pimsy/get-settings',

      syncEmployees: 'v2/integrations/pimsy/sync-employees',
      employees: 'v2/integrations/pimsy/employees',
      mapEmployee: 'v2/integrations/pimsy/map-employee',
      bulkMapEmployee: 'v2/integrations/pimsy/map-employee-bulk',
      mapEmployeeById: 'v2/integrations/pimsy/map-employee/{employeeId}',
      employeeById: 'v2/integrations/pimsy/employees/{employeeId}',
      importEmployees: 'v2/integrations/pimsy/import-employee-bulk',
      timeeroEmployees: 'v2/integrations/pimsy/timeero-users',

      syncJobs: 'v2/integrations/pimsy/sync-jobs',
      jobs: 'v2/integrations/pimsy/jobs',
      mapJob: 'v2/integrations/pimsy/map-job',
      bulkMapJob: 'v2/integrations/pimsy/map-job-bulk',
      mapJobById: 'v2/integrations/pimsy/map-job/{jobId}',
      jobById: 'v2/integrations/pimsy/jobs/{jobId}',
      importJobs: 'v2/integrations/pimsy/import-job-bulk',
      timeeroJobs: 'v2/integrations/pimsy/timeero-jobs',
      syncSchedules: 'v2/integrations/pimsy/sync-schedules',
    },
    everee: {
      connect: 'v2/everee/connect',
      disconnect: 'v2/everee/disconnect',
      syncWorkers: 'v2/everee/sync',
      workers: 'v2/everee/workers',
      timeeroEmployees: 'v2/everee/users',
      importWorkers: 'v2/everee/import-workers',
      mapWorkers: 'v2/everee/map-workers',
      removeMappings: 'v2/everee/remove-mappings',
      payables: 'v2/everee/payables',
      bulkMapUnmapWorkers: 'v2/everee/map-bulk-workers',
    },

    paycor: {
      connect: 'v2/paycor/connect',
      disconnect: 'v2/paycor/disconnect',
      token: 'v2/paycor/token',
      settings: 'v2/paycor/settings',
      syncModules: 'v2/paycor/sync',
      employees: 'v2/paycor/employees',
      timeeroUsers: 'v2/paycor/users',
      mapUnmapEmployee: 'v2/paycor/map-employees',
      bulkMapUnmap: 'v2/paycor/map-bulk-employees',
      mapEarningCodes: 'v2/paycor/map-earnings/{legalEntityId}',
      entities: 'v2/paycor/entities',
      timeeroEarnings: 'v2/paycor/timeero-earnings/{legalEntityId}',
      earnings: 'v2/paycor/earnings/{legalEntityId}',
      timeeroTasks: 'v2/paycor/tasks',
      laborCodes: 'v2/paycor/laborcodes',
      mapUnmapLaborCodes: 'v2/paycor/map-laborcodes',
      bulkMapUnmapLaborCodes: 'v2/paycor/map-bulk-laborcodes',
      payGroupByEntityId: 'v2/paycor/pay-groups/{entityId}',
    },
  },
  scheduling: {
    base: 'v2/schedules',
    calendarView: 'v2/schedules/calenders',
    scheduleById: 'v2/schedules/{id}',
    generateSubscribeUrl: 'v2/generate-subscribe-url',
    subcscribeUrls: 'v2/schedules-subscribe-urls',
    scheduleColors: 'v2/get-schedule-colors',
    updateShift: 'v2/update-shift',
    publishSchedule: 'v2/schedules/publish',
    importSchedule: 'v2/schedules/import',
    downloadImportScheduleSample: 'v2/download-schedule-csv-sample',

    //pending shifts
    pendingShifts: 'v2/schedules/pendings',
    acceptPendingShfit: 'v2/schedules/{shiftId}/accept',
    rejectPendingShift: 'v2/schedules/{shiftId}/decline',
  },
  shifts: {
    cherryPick: 'v2/get-shift-cherrypicks',
    acceptDecline: 'v2/accept-decline-shifts',
  },
  accountBilling: {
    billingDetails: 'v2/billing',
    addMethod: 'v2/billing/payment-methods',
    addOns: {
      purchase: 'v2/billing/purchase-add-ons',
      cancel: 'v2/billing/cancel-add-ons',
    },
    plans: 'v2/plans?duration={plan}',
    checkout: 'v2/billing/checkout',
    switchPlan: 'v2/billing/switchPlan',
    address: 'v2/billing/address',
    email: 'v2/billing/email',
    cancelPlan: 'v2/billing/cancel',
    resumePlan: 'v2/billing/resume',
    country: 'v2/countries',
    annualBilling: 'v2/annual-subscription-details',
  },
  reports: {
    base: 'v2/reports',
    weekIntervals: 'v2/reports/get-week-intervals',
    byMileage: 'v2/reports/mileage',
    byEmployee: 'v2/reports/employee',
    byDateRange: 'v2/reports/date-ranges',
    byTotalOnly: 'v2/reports/total-only',
    byJob: 'v2/reports/jobs',
    byTask: 'v2/reports/tasks',
    byBreak: 'v2/reports/breaks',
    byScheduleVsHoursWorked: 'v2/reports/schedule-vs-timesheets',
    dailySignOffs: 'v2/reports/cali-daily-sign-offs',
    premiumPay: 'v2/reports/premium-pay',
    dailyFlatRateByTotalReports: 'v2/reports/daily-flat-rate-total',
    dailyFlatRateByEmployeeReports: 'v2/reports/daily-flat-rate-employee',
    byWeekTotal: 'v2/reports/weeks-total',
    xeroReport: 'v2/reports/xero',
    segmentedTrackingReport: 'v2/reports/segmented-tracking',
    scheduleReportByUser: 'v2/reports/schedules',

    gustoPayPeriod: 'v2/reports/gusto-payroll-periods',
    exportMileageToGusto: 'v2/reports/export-mileage-gusto',
    exportTimeAndMileageToGusto: 'v2/reports/export-time-mileage-gusto',
    ADPRUNPayCycles: 'v2/adp-run/subscription/pay-cycles',
    quickBookPayPeriod: 'v2/reports/quickbooks-payroll-periods',
    exportMileageQuickbook: 'v2/reports/export-time-mileage-quickbooks-online',
    exportReportsToQuickBookDesktop: 'v2/reports/export-report-quickbooks-desktop',

    xeroPayPeriod: 'v2/reports/xero-pay-periods?user_id={id}',
    xeroEmployees: 'v2/reports/xero-users',

    ripplingPayPeriod: 'v2/reports/rippling-payroll-periods',
    exportReportsToRippling: 'v2/reports/export-report-rippling',

    exportReportsToPaychex: 'v2/reports/export-report-paychex',
    exportPaychexApi: 'v2/reports/export-paychex',

    adpPayPeriod: 'v2/reports/adp-payroll-periods',
    exportReportsToAdpWfn: 'v2/integrations/adp/exportToADPWFN',

    exportReportsToProliant: 'v2/reports/export-report-proliant',
    exportReportsToWorklio: 'v2/reports/export-report-worklio',
    exportReportsToPaylocity: 'v2/reports/export-report-paylocity-api',
    exportReportsToPaylocityCSV: 'v2/reports/export-report-paylocity-csv',
    exportReportsToADPCSV: 'v2/reports/export-adp-csv',
    exportReportsToXero: 'v2/reports/export-report-xero',
    exportReportsToViventium: 'v2/reports/export-report-viventium-api?export_type=time-mileage',
    exportReportsToPaycor: 'v2/reports/export-report-paycor',
    exportReportsToPaycorPaygrid: 'v2/paycor/export',
    exportReportsToADPRUN: 'v2/adp-run/subscription/export-timesheets',
    exportReportsToEveree: 'v2/everee/send-payables',

    downloadSegmentedReportsCSV: 'v2/download-segmented-reports/csv',
    downloadSegmentedReportsPDF: 'v2/download-segmented-reports/pdf',
    downloadScheduleReportsCSV: 'v2/download-schedule-reports/csv',
    downloadScheduleReportsPDF: 'v2/download-schedule-reports/pdf',
    downloadReportsCSV: 'v2/download-reports/csv',
    downloadReportsPDF: 'v2/download-reports/pdf',
    downloadTimesheetBaseDailySignoffReportsCSV: 'v2/download-timesheet-based-daily-signoff-reports/csv',
    downloadFilteredReportsCSV: 'v2/download-filtered-reports/csv',
    downloadFilteredReportsPDF: 'v2/download-filtered-reports/pdf',
    downloadGPSCoordinatesCSV: 'v2/download-gps-coordinates-reports/csv',
    downloadJobsCSV: 'v2/download-jobs-reports/csv',
    downloadUsersCSV: 'v2/download-users-reports/csv',

    // custom fields
    customFieldsReports: 'v2/reports/custom-fields',
    customFieldsTemplates: 'v2/reports/custom-fields/templates',
    customFieldsTemplateById: 'v2/reports/custom-fields/templates/{id}',
  },
  notification: {
    paginate: 'v2/notifications/paginate',
    notificationById: 'v2/notifications/{id}',
    markallRead: 'v2/notification-mark-all-read',
  },
  evv: {
    employee: 'v2/evv-employees',
    evvEmployeeById: 'v2/evv-employees/{employeeId}',
    mapEmployeeToTimeeroUser: 'v2/evv-employees/{employeeId}/map-user/{userId}',
    unlinkEmployeeToTimeeroUser: 'v2/evv-employees/{employeeId}/map-user',
    client: 'v2/evv-clients',
    evvClientById: 'v2/evv-clients/{clientId}',
    mapEvvClientToJob: 'v2/evv-clients/{clientId}/map-job/{jobId}',
    unlinkEvvClientToTimeeroJob: 'v2/evv-clients/{clientId}/map-job',
    pendingVisits: 'v2/evv-visits/pending',
    syncedVisits: 'v2/evv-visits/synced',
    failedVisits: 'v2/evv-visits/failed',
    syncVisits: 'v2/evv-visits/bulk-sync',
    bulkMarkAsSynced: 'v2/evv-visits/mark-as-synced',
    nonBillable: 'v2/evv-visits/{visitId}/not-billable',
  },

  customField: {
    moduleList: '/v2/customforms/objects',
    module: '/v2/customforms/ui/{module}',
    moduleById: '/v2/customforms/ui/{module}/{id}',
    rearrangeField: '/v2/customforms/ui/{module}/arrange',
    deleteField: 'v2/customforms/ui/{module}/delete',
    deactivateField: 'v2/customforms/ui/{module}/deactivate',
    activateField: 'v2/customforms/ui/{module}/activate',
  },
};
